"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dkCompanyNumberChecker = void 0;
var CVR_NUMMER_REGEX = /^\d{8}$/;
var dkCompanyNumberChecker = exports.dkCompanyNumberChecker = function dkCompanyNumberChecker(companyNumber) {
  return CVR_NUMMER_REGEX.test(companyNumber);
};